import { Component, Inject, ViewContainerRef, ViewChild, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicComponentLoaderService } from './../services/dynamic-component-loader.service';
import { ModalService } from './../services/modal.service';
import { PostauthComponent } from './../flashworlds/postauth.component';
import { MatDialog } from '@angular/material/dialog';
import { NeverumeComponent } from "./../neverume.component";
import { EventRunner } from './../core/app.core.events';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  providers: [DynamicComponentLoaderService]  ,
  standalone: !true
})
export class ModalComponent {
	@ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;
	  
	  
	  constructor(public dialogRef: MatDialogRef<ModalComponent>,
			  @Inject(MAT_DIALOG_DATA) public data: any,
			    private dynamicComponentLoader: DynamicComponentLoaderService,
			    private modalService: ModalService,
			    private dialog: MatDialog) {
		    this.dynamicComponentContainer = {} as ViewContainerRef;
		    }
	  
	  ngAfterViewInit(): void {
		  
		    this.modalService.getModal().subscribe(component => {
		    	if(typeof  component === 'string' && (<string>component).length > 0){
			  this.dynamicComponentLoader.loadFromRoute(this.dynamicComponentContainer, component);
		    }else{
		      this.dynamicComponentLoader.loadComponent(this.dynamicComponentContainer, PostauthComponent);
		    }
		    }
		    );
		  }
	  
	  public 	 openModal() {
		   this.dialog.open(ModalComponent, {});
		  }
	  
	  
	  
	  close(): void {
	    this.dialogRef.close();
	  }
	}
